import { getPersistValue } from '/b2b/common/state/persist/Persist.selectors';

const emptyObject = {};

export const getPersistedRequestListState = state =>
    getPersistValue(state, 'dsar.requestList', emptyObject);

export const getPersistedActionItemListState = state =>
    getPersistValue(state, 'dsar.actionItemList', emptyObject);

export const getPersistedFormListState = state =>
    getPersistValue(state, 'dsar.formList', emptyObject);

// Forms-list UI state (e.g. card/table view). Kept under a sibling path so the
// REPLACE on `dsar.formList` (fires on every results fetch) doesn't wipe it.
// Falls back to the legacy `dsar.formListV2` key so a user's saved view survives
// the rename (the write path is the new key, so old entries migrate on next toggle).
export const getPersistedFormListViewState = state =>
    getPersistValue(state, 'dsar.formListView') ??
    getPersistValue(state, 'dsar.formListV2', emptyObject);

export const getPersistedWorkflowListState = state =>
    getPersistValue(state, 'dsar.workflowList', emptyObject);
